import script from "./MyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MyModal.vue?vue&type=script&setup=true&lang=js"

import "./MyModal.vue?vue&type=style&index=0&id=52b5438b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b5438b"]])

export default __exports__